import * as angular from 'angular';
import * as _ from 'lodash';

import { ITicketService } from '../../services';
import { Ticket } from '../../models';
import { Store } from '../Store';
import * as TICKETS from './tickets.constants';

import {
    loadTickets,
    loadTicketsSuccess,
    updateTickets,
    updateTicketsSuccess,
    addTicketsSuccess,
    addTickets
} from './tickets.actions';
import { ITicketTypesActionsService } from '../ticketTypes/ticketTypes.actionCreator';

export interface ITicketActionsService {
    getOne(id: number, force?: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket[]>;
    addOne(target: Ticket): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket[]>;
    addMany(targets: Ticket[]): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket[]>;
    updateOne(target: Ticket): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket[]>;
    updateMany(targets: Ticket[]): (dispatch: any, getState: () => Store) => angular.IPromise<Ticket[]>;
}

export class TicketsActionsService implements ITicketActionsService {

    static serviceId = 'ticketActionsService';
    static $inject = ['$q', 'ticketService', 'ticketTypesActionsService'];


    constructor(
        private _$q: angular.IQService,
        private _ticketService: ITicketService,
        private _ticketTypesActionsService: ITicketTypesActionsService
    ) {
    }

    getOne(id: number, force = true) {
        return (dispatch: any, getState: () => Store) => {
            const { tickets } = getState();
            if (force || (!tickets.isLoading && !tickets.isLoaded)) {
                dispatch(loadTickets());
                return this._ticketService
                    .getAll(true)
                    .then(data => {
                        if (data && data.length) {
                            const result = data.filter(c => c.id === id);
                            dispatch(loadTicketsSuccess(data));
                            return result;
                        } else {
                            dispatch({ type: TICKETS.TICKETS_LOAD_ERROR, payload: data });
                            return data;
                        }
                    })
                    .catch((reason) => {
                        dispatch({ type: TICKETS.TICKETS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<Ticket>(tickets.dictionary), c => c.id === id));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { tickets } = getState();
            if (force || (!tickets.isLoading && !tickets.isLoaded)) {
                dispatch(loadTickets());
                return this._ticketService
                    .getAll(force)
                    .then(data => {
                        if (data && data.length >= 0) {
                            dispatch(loadTicketsSuccess(data));
                            return data;
                        } else {
                            dispatch({ type: TICKETS.TICKETS_LOAD_ERROR, payload: data });
                            return data;
                        }
                    })
                    .catch((reason) => {
                        dispatch({ type: TICKETS.TICKETS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Ticket>(tickets.dictionary));
            }
        };
    }

    addOne(target: Ticket) {
        return this.addMany([target]);
    }

    addMany(targets: Ticket[]) {
        return (dispatch: any, getState: () => Store) => {
            const { tickets } = getState();
            if (targets && targets.length > 0) {
                dispatch(addTickets(targets));
                return this._ticketService
                    .addMany(targets)
                    .then(data => {
                        // refresh parents if count has changed
                        this.updateParents(targets, dispatch, getState);
                        // refresh types if auto-delete occured
                        this._ticketTypesActionsService.getAll(true)(dispatch, getState);
                        if (data && data.length) {
                            const result = data;
                            dispatch(addTicketsSuccess(result));
                            return result;
                        } else {
                            dispatch({ type: TICKETS.TICKETS_ADD_ERROR, payload: data });
                            return data;
                        }
                    })
                    .catch((reason) => {
                        dispatch({ type: TICKETS.TICKETS_ADD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Ticket>(tickets.dictionary));
            }
        };
    }

    updateOne(target: Ticket) {
        return this.updateMany([target]);
    }

    updateMany(targets: Ticket[]) {
        return (dispatch: any, getState: () => Store) => {
            const { tickets } = getState();
            if (targets && targets.length > 0) {
                dispatch(updateTickets(targets));
                return this._ticketService
                    .updateMany(targets)
                    .then(data => {
                        // refresh parents if count has changed
                        this.updateParents(targets, dispatch, getState);
                        // refresh types if auto-delete occured
                        this._ticketTypesActionsService.getAll(true)(dispatch, getState);
                        if (data && data.length) {
                            const result = data;
                            dispatch(updateTicketsSuccess(result));
                            return result;
                        } else {
                            dispatch({ type: TICKETS.TICKETS_UPDATE_ERROR, payload: data });
                            return data;
                        }
                    })
                    .catch((reason) => {
                        dispatch({ type: TICKETS.TICKETS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Ticket>(tickets.dictionary));
            }
        };
    }

    private updateParents(targets: Ticket[], dispatch: any, getState: () => Store) {
        if (_.some(targets, t => t.parentTicketId)) {
            if (targets.length === 1) {
                this.getOne(targets[0].parentTicketId, true)(dispatch, getState);
            }
            else {
                this.getAll(true)(dispatch, getState);
            }
        }
    }
}